import { render, staticRenderFns } from "./ContentRecibo.vue?vue&type=template&id=62255a16&"
import script from "./ContentRecibo.vue?vue&type=script&lang=js&"
export * from "./ContentRecibo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports